import { createApp } from 'vue';
import App from './App.vue';
import store from './store';
import VueObserveVisibility from 'vue-observe-visibility';

const app = createApp(App);

app.use(store);
app.use(VueObserveVisibility);
app.mount('#app');